import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SplatDuplicateIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M20.5 1.25H9.5C8.54 1.25 7.75 2.04 7.75 3V6.25H4C3.04 6.25 2.25 7.04 2.25 8V21C2.25 21.96 3.04 22.75 4 22.75H15C15.96 22.75 16.75 21.96 16.75 21V17.75H20.5C21.46 17.75 22.25 16.96 22.25 16V3C22.25 2.04 21.46 1.25 20.5 1.25ZM15.25 21C15.25 21.14 15.14 21.25 15 21.25H4C3.86 21.25 3.75 21.14 3.75 21V8C3.75 7.86 3.86 7.75 4 7.75H7.75V16C7.75 16.96 8.54 17.75 9.5 17.75H15.25V21ZM20.75 16C20.75 16.14 20.64 16.25 20.5 16.25H9.5C9.36 16.25 9.25 16.14 9.25 16V3C9.25 2.86 9.36 2.75 9.5 2.75H20.5C20.64 2.75 20.75 2.86 20.75 3V16Z"
        fill={color}
      />
      <path
        d="M12.63 5.5H11.62C11.2776 5.5 11 5.77758 11 6.12V7.13C11 7.47242 11.2776 7.75 11.62 7.75H12.63C12.9724 7.75 13.25 7.47242 13.25 7.13V6.12C13.25 5.77758 12.9724 5.5 12.63 5.5Z"
        fill={color}
      />
      <path
        d="M12.63 11.25H11.62C11.2776 11.25 11 11.5276 11 11.87V12.88C11 13.2224 11.2776 13.5 11.62 13.5H12.63C12.9724 13.5 13.25 13.2224 13.25 12.88V11.87C13.25 11.5276 12.9724 11.25 12.63 11.25Z"
        fill={color}
      />
      <path
        d="M18.38 11.25H17.37C17.0276 11.25 16.75 11.5276 16.75 11.87V12.88C16.75 13.2224 17.0276 13.5 17.37 13.5H18.38C18.7224 13.5 19 13.2224 19 12.88V11.87C19 11.5276 18.7224 11.25 18.38 11.25Z"
        fill={color}
      />
      <path
        d="M18.38 5.5H17.37C17.0276 5.5 16.75 5.77758 16.75 6.12V7.13C16.75 7.47242 17.0276 7.75 17.37 7.75H18.38C18.7224 7.75 19 7.47242 19 7.13V6.12C19 5.77758 18.7224 5.5 18.38 5.5Z"
        fill={color}
      />
      <path
        d="M15.51 8.38H14.5C14.1576 8.38 13.88 8.65759 13.88 9V10.01C13.88 10.3524 14.1576 10.63 14.5 10.63H15.51C15.8524 10.63 16.13 10.3524 16.13 10.01V9C16.13 8.65759 15.8524 8.38 15.51 8.38Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SplatDuplicateIcon.displayName = 'SplatDuplicateIcon';
